var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.wrpCls,staticStyle:{"margin-right":"0"}},[_c('a-space',{attrs:{"size":20}},[_c('screenfull'),_c('refresh'),_c('CompaniesList'),_c('avatar-dropdown',{class:_vm.prefixCls,staticStyle:{"background-color":"#F6F6F6"},attrs:{"menu":_vm.showMenu,"current-user":_vm.currentUser}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }